import * as THREE from 'three';
class VideoTexture extends THREE.VideoTexture {
    video;
    constructor(url) {
        const video = document.createElement('video');
        super(video);
        this.video = video;
        this.addVideo(url);
    }
    addVideo(url) {
        this.video.src = url;
        this.video.autoplay = true;
        this.video.loop = true;
        this.video.style.width = '1px';
        this.video.muted = true;
        const temp = document.createElement('div');
        temp?.appendChild(this.video);
        const style = {
            opacity: 0,
            width: 0,
            height: 0,
            position: 'fixed',
            left: 0,
            top: 0,
        };
        for (const key in style) {
            temp.style[key] = style[key].toString();
        }
        document.body.appendChild(temp);
    }
}
export default VideoTexture;
